import React, { Component } from 'react';
import '../css/validations.css'


class InvoiceDataModal extends Component {
    
    render() {
        const{ShowBillModal}=this.props;
        return (
            <div>
                <div className="modal fade" id="invoiceDataModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="invoiceDataModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="container" >
                                    <h4>Datos de facturación</h4>
                                    <form>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__rfc">
                                                    <label htmlFor="rfc">RUT</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="RUT"
                                                            id="rfc"
                                                            value={""}
                                                            onChange={""} 
                                                            onBlur={""}/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group" id="grupo__firstName">
                                                    <label htmlFor="firstName">Calle</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Calle"
                                                            id="street"
                                                            name="street"
                                                            value= ""
                                                            onChange=""
                                                            onBlur=""/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo letras, min 3 y max 15.</p>
                                                    <p className="form__input-void">Nombre no puede ir vacio.</p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__lastName">
                                                    <label htmlFor="lastName">Número</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Número exterior/interior"
                                                            id="numberEXT"
                                                            name="numberEXT"
                                                            value=""
                                                            onChange="" 
                                                            onBlur=""/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo letras, min 3 y max 35.</p>
                                                    <p className="form__input-void">Apellido no puede ir vacio.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__cardCode">
                                                    <label htmlFor="cardCode">Colonia</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Colonia"
                                                            id="district"
                                                            value=""
                                                            onChange=""
                                                            onBlur=""/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo letras, números o guiones, min 3 y max 16.</p>
                                                    <p className="form__input-void">Código no puede ir vacio.</p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__cardCode">
                                                    <label htmlFor="cardCode">Municipio</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Municipio"
                                                            id="township"
                                                            value=""
                                                            onChange=""
                                                            onBlur=""/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo letras, números o guiones, min 3 y max 16.</p>
                                                    <p className="form__input-void">Código no puede ir vacio.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group formulario__grupo" id="grupo__rfc">
                                                    <label htmlFor="pc">Código postal</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="C.P."
                                                            id="PC"
                                                            value=""
                                                            onChange=""
                                                            onBlur={this.ValidateLicTradNum}/>
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>                                                    
                                                </div>
                                            </div>
                                            <div className="col-12 form-group formulario__grupo" id="grupo__rfc">
                                                <p className="form__input-error" style={{marginTop: "-14px"}}>{"Formatos validos: (XAXX010101000), (XAXX-010101-000) o (XAXX 010101 000)"}</p>
                                                <p className="form__input-void" style={{marginTop: "-14px"}}>RUT no puede ir vacio.</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                            <div className="form-group">
                                                    <label htmlFor="first-name">Estado</label>
                                                    <select
                                                        id="nameState"
                                                        className="form-control"
                                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                        value=""
                                                        onChange="">
                                                        <option selected>Seleccione uno</option>
                                                        <option value="1">Hidalgo</option>
                                                        <option value="2">Veracruz</option>
                                                        <option value="3">Baja California</option>
                                                        <option value="4">Estado de Mexico</option>
                                                        <option value="5">Ciudad de Mexico</option>
                                                        <option value="6">Sinaloa</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label htmlFor="first-name">País</label>
                                                    <select
                                                        id="country"
                                                        className="form-control"
                                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                        value=""
                                                        onChange="">
                                                        <option selected>Seleccione uno</option>
                                                        <option value="1">Mexico</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </form>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="col-sm-12">
                                    <div className="m-2 row">
                                        <button type="button" className="btn-lg btn-secondary col-3 ml-2 mr-4" data-dismiss="modal" data-target="" data-toggle="modal">Cancelar</button>
                                        <button className="btn-lg btn-primary d-block w-100 col-8" type="submit" data-dismiss="modal" data-target="#billModal"  data-toggle="modal" onClick={ShowBillModal} >Guardar</button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InvoiceDataModal;